import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { 
  FaChartLine, 
  FaShieldAlt, 
  FaRegLightbulb,
  FaUserTie,
  FaBalanceScale
} from 'react-icons/fa';

const FeatureCard = ({ icon, title, description, delay, link }) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay }}
      viewport={{ once: true, margin: "-100px" }}
      className="bg-white rounded-xl p-8 shadow-custom hover:shadow-custom-lg transition-all duration-300 transform hover:-translate-y-2 h-full flex flex-col"
    >
      <div className="bg-secondary/10 p-4 rounded-full w-16 h-16 flex items-center justify-center mb-6">
        {icon}
      </div>
      <h3 className="text-2xl font-heading font-semibold mb-4 text-primary">{title}</h3>
      <p className="text-gray-600 mb-6 flex-grow">{description}</p>
      <Link 
        to={link} 
        className="btn btn-outline-secondary text-sm py-2 px-4 inline-flex items-center hover:bg-secondary hover:text-white transition-all duration-300 mt-auto"
      >
        Learn More
        <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
        </svg>
      </Link>
    </motion.div>
  );
};

const FeaturesSection = () => {
  const features = [
    {
      icon: <FaChartLine className="w-8 h-8 text-secondary" />,
      title: "Wealth Management",
      description: "We are trusted Wealth Managers that focus on delivering investment solutions for our diverse range of clients based on our broad and accurate insight of financial markets.",
      link: "/services/wealth-management"
    },
    {
      icon: <FaRegLightbulb className="w-8 h-8 text-secondary" />,
      title: "Financial Planning",
      description: "Segway Capital Management Financial Planning offers expert advice and assistance on reaching your financial goals and objectives. Get insight from our financial experts.",
      link: "/services/financial-planning"
    },
    {
      icon: <FaShieldAlt className="w-8 h-8 text-secondary" />,
      title: "Retirement Planning",
      description: "Whatever your financial needs are, at Segway Capital we help you figure out the right type of investments to help generate enough income and plan your finances efficiently.",
      link: "/services/retirement-planning"
    },
    {
      icon: <FaUserTie className="w-8 h-8 text-secondary" />,
      title: "Managed Portfolios",
      description: "Managed Portfolios provide professionally managed, broadly diversified portfolios of mutual funds or exchange-traded funds (ETFs) with competitive fees and minimums.",
      link: "/services/managed-portfolios"
    },
    {
      icon: <FaBalanceScale className="w-8 h-8 text-secondary" />,
      title: "Wealth & Estate Planning",
      description: "Comprehensive wealth and estate planning services to preserve and transfer your legacy. Our professionals work with your advisory team to develop strategies for your entire financial picture.",
      link: "/services/wealth-estate-planning"
    }
  ];

  return (
    <section id="features" className="py-20 bg-background relative">
      <div className="container-custom">
        <motion.div 
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl font-heading font-bold text-primary mb-6">We Offer Wealth Management Solutions</h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Segway Capital Management offers a personal and proactive approach to managing your wealth. We take the time to get to know you and understand your ambitions and create unique solutions for every stage of your life's journey.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <FeatureCard 
              key={index}
              icon={feature.icon}
              title={feature.title}
              description={feature.description}
              delay={0.2 * index}
              link={feature.link}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection; 